import React, { useEffect, useRef } from 'react';
import { Route, Routes } from "react-router-dom";

import { useState } from 'react';

// css 
import './ComponentsCss/SpCase1.css';
import './ComponentsCss/UserInfo.css';
import axios from 'axios';

import useAuth from '../hooks/useAuth.js';
import toast, { Toaster } from 'react-hot-toast';
import PersistLogin from './PersistLogin';
import UserInfo from './UserInfo.js';


// imgs 
import signImg from "../imgs/sign.png";
import LogoImg from "../imgs/logo-hori.png";


const notify = (Text) => toast.success(Text);
const errNotify = (Text) => toast.error(Text);
const LOGIN_URL = 'userauth/login';
const SpCase1 = () => {

  const [CreateProfileBool, SetCreateProfileBool] = useState(true);
  const [UserId, SetUserId] = useState("");
  const [UserPw, SetUserPw] = useState("");
  const [ConfirmUserPw, SetConfirmUserPw] = useState("");
  const [UserName, SetUserName] = useState("");
  const [UserBD, SetUserBD] = useState("");

  const [UserEmail, SetUserEmail] = useState("");
  const [UserMobile, SetUserMobile] = useState("");

  const [UserData, SetUserData] = useState();
  const [UserAddress, SetUserAddress] = useState("");

  const [token_version_id, set_token_version_id] = useState("");
  const [enc_data, set_enc_data] = useState("");
  const [integrity, set_integrity] = useState("");
  const [key, set_key] = useState("");
  const [iv, set_iv] = useState("");
  const [hmac_key, set_hmac_key] = useState("");
  const [req_no, set_req_no] = useState("");

  // login page 
  const [LoginSuccess, SetLoginSuccess] = useState(false);
  const { setAuth, auth, persist, setPersist } = useAuth();

  // show form 
  const [UserDetailSuccess, SetUserDetailSuccess] = useState(false);
  // loader circle 
  let [LoadingCir, SetLoadingCir] = useState("#253b60");
  const [LoadingCirBool, SetLoadingCirBool] = useState(false);


  const togglePersist = () => {
    setPersist(prev => !prev);
  }
  useEffect(() => {
    localStorage.setItem("persist", persist);
  }, [persist])

  useEffect(() => {

    //SetUserDetailSuccess(false);
    if (CreateProfileBool == true) {
      axiosNiceApiInit();
    }
  }, [CreateProfileBool]);


  function SetNiceApiDetails(data) {
    set_token_version_id(data?.token_version_id);
    set_enc_data(data?.enc_data);
    set_integrity(data?.integrity);
    set_key(data?.key);
    set_iv(data?.iv);
    set_hmac_key(data?.hmac_key);
    set_req_no(data?.req_no);


  }



  function SetUserDetails(data) {
    // user details 
    SetUserName(data?.name);
    SetUserBD(data?.birthdate);
    SetUserMobile(data?.mobileno);
  }

  const openInNewTab = (url) => {
    restartStatusCheck();
    const windowName = '_blank'; // or a specific name
    const windowFeatures = 'height=600,width=800,left=200,top=100';

    window.open(url, windowName, windowFeatures);
  };


  const axiosStatusCheckTimer = useRef();
  useEffect(() => {
    return () => CloseCleanUp();
  }, []);

  function CloseCleanUp() {
    clearInterval(axiosStatusCheckTimer.current);
  }
  function restartStatusCheck() {
    stopAxiosStatusCheck();
    startAxiosStatusCheck();
  }
  const startAxiosStatusCheck = () => {
    //console.log(" startAxiosStatusCheck()");
    axiosStatusCheckTimer.current = setInterval(() => {
      axiosNiceGetSession();

    }, 2000);
  };
  const stopAxiosStatusCheck = () => {
    console.log(" stopAxiosStatusCheck()");
    clearInterval(axiosStatusCheckTimer.current);
  };
  // axios 
  // test axios 
  // http://localhost/userauth/allUsers 
  const axiosNiceApiInit = async () => {

    console.log(" GET AXIOS TEST ");
    try {
      const response = await axios.get("http://15.165.205.88:8888/checkplus_main_custom"
      );
      if (response) {
        //console.log(JSON.stringify(response.data, null, 2));
        SetNiceApiDetails(response.data);

      }

    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Missing Username or Password');
      } else if (err.response?.status === 401) {
        console.log('--Unauthorized');
      } else {
        console.log('ERR');
      }

    }
  }

  const axiosNiceGetSession = async () => {

    console.log(" axiosNiceGetSession");
    try {
      const response = await axios.get("http://15.165.205.88:8888/getsession"
      );
      if (response) {
        console.log(response.data);
        const data = JSON.parse(response.data);

        if (data && data.responseno != "" && data.name != "" && data.birthdate != "" && data.gender != "") {
          SetUserDetails(data);
          stopAxiosStatusCheck();
          SetUserDetailSuccess(true);
          SetLoadingCirBool(false);
          axsioDeleteSession();
        } else {
          SetUserDetailSuccess(false);
          SetLoadingCirBool(true);
        }

        //var dataJson = JSON.parse(response?.data).data;
        //console.log(dataJson);
        //console.log(dataJson.name);
        //
      } else {
        SetUserDetailSuccess(false);
        SetLoadingCirBool(true);
      }

    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Missing Username or Password');
      } else if (err.response?.status === 401) {
        console.log('--Unauthorized');
      } else {
        console.log('ERR');
      }

    }
  }

  const axsioDeleteSession = async () => {

    console.log("axsioDeleteSession ");
    try {
      const response = await axios.get("http://15.165.205.88:8888/deleteSession"
      );


    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Missing Username or Password');
      } else if (err.response?.status === 401) {
        console.log('--Unauthorized');
      } else {
        console.log('ERR');
      }

    }
  }



  const axiosPostPOA = async () => {
    console.log(" axiosPostPOA user ");
    try {
      // const { userId, userPw, confUserPw, userName, 
      //        userEmail, userMobile, userRole } = req.body;
      var DataJson = "";
      DataJson = JSON.stringify({
        userId: "sp-case-1" + UserName, // sp case 1 
        userName: UserName,
        userAddress: UserAddress,
        userMobile: UserMobile,
        userPOA: 1
      }, null, 2);

      console.log("AXIOS Registering user POA : " + DataJson);
      var finalIP = "";
      // 	"/emergency/rssi/module-status-set/<ip>"
      finalIP = "https://15.165.205.88/api/spcasePOA";
      //console.log(" axiosPostModuleStatus" + finalIP);
      const response = await axios.post(finalIP,
        DataJson,
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,

        }
      );
      if (response) {
        console.log(" POA success !");
        notify("보조참가 신청을 완료 하셨습니다");

      }
    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Username and password are required.');
        //errNotify("ID 와 비밀번호를 입력 해주세요.");
      } else if (err.response?.status === 401) {
        console.log('-- Wrong conf password ');
        //errNotify("비밀번호 확인에 같은 비밀번호를 입력해주세요. ");
      }
      else if (err.response?.status === 402) {
        console.log('-- Username already exists ');
        errNotify("이미 위임장을 작성하셨습니다. 감사합니다.");

      } else {
        console.log('ERR');
      }

    }
  }

  function getDate() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    return `${year}년 ${month}월 ${date}일 `;
  }
  function POACheck() {
    if (UserDetailSuccess == false) {
      errNotify("본인인증을 진행해주세요.");
    } else {
      if (UserAddress == "") {
        errNotify("주소를 입력해주세요.");

      } else if (UserAddress.length > 0) {
        axiosPostPOA();
      }
    }

  }

  function fnPopup() {
    restartStatusCheck();
    window.open('', 'popupChk', 'width=480, height=812, top=100, fullscreen=no, menubar=no, status=no, toolbar=no,titlebar=yes, location=no, scrollbar=no');
    document.form_chk.action = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
    document.form_chk.target = "popupChk";
    document.form_chk.submit();

  }
  /* 


  */
  return (
    <>
      <div style={{ height: "100px" }}>
      </div>
      <div className="login-container">

        <div className="login-box" >

          {
            CreateProfileBool == true ?

              <>
                <>
                  <div className="FlexCol">
                    <div className="Title">
                      보조참가신청
                    </div>
                    <div className="SubTitle" style={{ textAlign: "center" }} >
                      사건: 동성커플 피부양자 인정
                      대법원 판결 취소 헌법소원(2024사건번호)
                    </div>
                    <br />
                    <div className="SubTitle" >
                      보조참가인 인적사항
                    </div>
                    <div>
                      {
                        UserDetailSuccess == true ?
                          <>
                            <div className="FlexRow">
                              <div className="ColTitle">성명</div>
                              <div className="ColText"> {UserName} </div>
                            </div>
                            <div className="FlexRow">
                              <div className="ColTitle">상세주소</div>
                              <input type='text' className="ColText" value={UserAddress} onInput={e => SetUserAddress(e.target.value)} />
                            </div>
                            <div className="FlexRow">
                              <div className="ColTitle">전화번호</div>
                              <div className="ColText"> {UserMobile} </div>
                            </div>
                          </>
                          :
                          <>
                            <div className="FlexRow">
                              <div className="ColTitle">성명</div>
                              
                              <input type='text' className="ColText" value={UserName} onInput={e => SetUserName(e.target.value)} />
                            </div>
                            <div className="FlexRow">
                              <div className="ColTitle">상세주소</div>
                              <input type='text' className="ColText" value={UserAddress} onInput={e => SetUserAddress(e.target.value)} />
                            </div>
                            <div className="FlexRow">
                              <div className="ColTitle">전화번호</div>
                              <div className="ColText">  <button class="mobile-button-small" onClick={() => fnPopup()}>
                                전화번호 인증 하러가기
                              </button> </div>
                            </div>


                          </>
                      }


                    </div>

                    <div className="SubTitle" >
                      대리인 인적사항
                    </div>
                    <div>
                      <div className="FlexRow">
                        <div className="ColTitle">성명</div>
                        <div className="ColText"> 도태우</div>
                      </div>
                      <div className="FlexRow">
                        <div className="ColTitle">상세주소</div>
                        <div className="ColText"> 서울특별시 영등포구 국회대로 750 금산빌딩 712호 </div>
                      </div>
                      <div className="FlexRow">
                        <div className="ColTitle">전화번호</div>
                        <div className="ColText"> 010-5663-6907 </div>
                      </div>
                    </div>

                    <div className="SubTitle" >
                      참가 취지
                    </div>
                    <div>
                      <div className="LeftTextBox">
                        위 사건에 관하여 청구인(원고) 보조참가인은 헌법재판소법 제40조 제1항 및 민사소송법 제71조에 따라
                        청구인(원고)을 보조하기 위하여 보조참가를 신청합니다.
                      </div>
                    </div>

                    <div className="FlexCol">
                      <div className="CenterTextBox" > 보조참가신청 및 관련사무 일체를 대리인에게 보조참가신청을 대리인에게 위임합니다.</div>
                      <div className="CenterTextBox">
                        {getDate()}
                      </div>
                      <button className="mobile-button " onClick={() => POACheck()} >

                        보조참가신청 위임장 제출하기
                      </button>
                    </div>

                    <hr
                      style={{
                        color: "black",
                        width: "100%",
                        height: "1px"
                      }}
                    />

                    <div className="FlexCol">
                      <div className="CenterTextBox" > 본인은 업무를 진행하는 과정 취득한 정보를 본 목적 외에 다른 용도로 사용하지 않습니다.</div>
                      <div className="CenterTextBox">
                        {getDate()}
                      </div>
                      <div className='FlexRow justify-center'>
                        <div className="CenterTextBox bold align-items-center" style={{ width: "auto" }}> 수임자 성명 도태우 </div>
                        <img src={signImg} className='SignImg' />
                      </div>
                      <div className='FlexRow justify-center'>
                        <img src={LogoImg} className='logoImg' />
                      </div>


                    </div>
                  </div>
                  <br />


                </>
                <div className="input-group" >
                  <form name="form_chk" method="post">
                    <input type="hidden" name="m" value="service" />
                    <input type="hidden" name="token_version_id" value={token_version_id} />
                    <input type="hidden" name="enc_data" value={enc_data} />
                    <input type="hidden" name="integrity_value" value={integrity} />
                  </form>
                </div>



              </>
              :
              null
          }
          <div style={{ marginBottom: "100px" }}></div>
        </div>
      </div>
    </>
  )
}

export default SpCase1